<template>
  <div
    :class="[
      'carousel',
      { 'carousel--stack-on-mobile': stackOnMobile },
      {
        'carousel-vertical': vertical,
        'carousel-text-selectable': !swipeOnDesktop,
      },
    ]"
    :id="carouselIdentifier"
  >
    <div class="carousel-wrapper">
      <ul
        ref="carouselInner"
        class="carousel-inner"
        :style="{
          transform: `translate${this.vertical ? 'Y' : 'X'}(${
            this.currentOffset
          }px)`,
          transition: this.transitionStyle,
          flexBasis: this.isVideoCarousel ? 'unset' : `${this.slideWidth}px`,
          msFlexPreferredSize: `${this.slideWidth}px`,
          visibility: `${this.slideWidth ? 'visible' : 'hidden'}`,
        }"
      >
        <slot />
      </ul>
    </div>
    <pagination v-if="paginationEnabled && pageCount > 0" :labels="labels" />
    <navigation
      :show-navigation="showNavigation"
      :autoplay="autoplay"
      @changeSlide="advancePage"
      @toggleAutoPlay="toggleAutoPlay"
      :labels="labels"
    />
  </div>
</template>

<script>
  import CarouselMixin from './carouselMixin.js';
  import Navigation from '../navigation/navigation.vue';
  import Pagination from '../pagination/pagination.vue';
  import Slide from '../slide/slide.vue';

  export default {
    name: 'carousel',
    components: {
      Navigation,
      Pagination,
      Slide,
    },
    mixins: [CarouselMixin],
  };
</script>

<style lang="scss"  src="./carousel.scss"></style>

